var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    !_vm.quotes || _vm.quotes.length <= 0
      ? _c("h1", [
          _vm._v(
            "To retrieve, progress or amend your quote enter the unique quote ID we emailed you below"
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.quotes || _vm.quotes.length <= 0
      ? _c("div", { staticClass: "dashboard-form" }, [
          _c("div", [
            _c("div", { staticClass: "form-row" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.quote_uniqid,
                    expression: "quote_uniqid"
                  }
                ],
                staticClass: "form-input",
                staticStyle: { margin: "0 auto" },
                attrs: {
                  id: "Quoteid",
                  type: "text",
                  placeholder: "Quote id",
                  required: ""
                },
                domProps: { value: _vm.quote_uniqid },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.quote_uniqid = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.quote_email,
                    expression: "quote_email"
                  }
                ],
                staticClass: "form-input",
                staticStyle: { margin: "0 auto" },
                attrs: {
                  id: "EmailToGetQuote",
                  type: "email",
                  placeholder: "Email",
                  required: ""
                },
                domProps: { value: _vm.quote_email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.quote_email = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c(
                "button",
                {
                  staticClass: "form-button",
                  on: {
                    click: function($event) {
                      return _vm.getQuotes()
                    }
                  }
                },
                [_vm._v("retrieve quote")]
              )
            ]),
            _vm._v(" "),
            _vm.quotes && _vm.quotes.length <= 0
              ? _c("div", { staticClass: "retrieve-quote-error" }, [_vm._m(1)])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.quotes && _vm.quotes.length > 0
      ? _c("div", { staticStyle: { "background-color": "#E7E6E6" } }, [
          _vm._m(2),
          _vm._v(" "),
          _c("table", { attrs: { id: "quotes-table" } }, [
            _c(
              "caption",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "18px",
                  padding: "20px 0px",
                  "text-align": "left"
                }
              },
              [_vm._v("Your quote details:")]
            ),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("ID:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sortedQuotes[0] ? _vm.sortedQuotes[0].uniqid : null
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Company name:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sortedQuotes[0].user
                        ? _vm.sortedQuotes[0].user.company_name
                        : null
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Office address:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.sortedQuotes[0].office_address))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [
                  _vm._v("Office postcode:")
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "cell-postcode value" }, [
                  _vm._v(_vm._s(_vm.sortedQuotes[0].office_postcode))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Updated at:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.sortedQuotes[0].updated_at))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Created at:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.sortedQuotes[0].created_at))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-gradient",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.loadQuote(_vm.sortedQuotes[0].id, 1)
                        }
                      }
                    },
                    [_vm._v("Amend Quote")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _vm.sortedQuotes[0].step3 ||
                    (_vm.sortedQuotes[0].step2 &&
                      !_vm.sortedQuotes[0].uses_franking_machine)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn btn-gradient",
                            attrs: {
                              tag: "a",
                              to: {
                                name: "results.index",
                                params: { quote_id: _vm.sortedQuotes[0].uniqid }
                              }
                            }
                          },
                          [_vm._v("View Results")]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "btn btn-gradient",
                            staticStyle: { color: "grey" }
                          },
                          [_vm._v("View Results")]
                        )
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.quotes && _vm.quotes.length > 0
      ? _c("div", [
          _c("div", {
            staticClass: "quoteSeparator",
            staticStyle: {
              background: "linear-gradient(45deg,#0a70e3,#f81e8c)",
              height: "5px",
              margin: "5px 0px"
            }
          }),
          _vm._v(" "),
          _c("table", { attrs: { id: "details-table" } }, [
            _c(
              "caption",
              {
                staticStyle: {
                  "font-weight": "bold",
                  "font-size": "18px",
                  padding: "20px 0px",
                  "text-align": "left"
                }
              },
              [_vm._v("Your personal details:")]
            ),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Name:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sortedQuotes[0].user
                        ? _vm.sortedQuotes[0].user.name
                        : null
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Email:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sortedQuotes[0].user
                        ? _vm.sortedQuotes[0].user.email
                        : null
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Contact phone:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.sortedQuotes[0].user
                        ? _vm.sortedQuotes[0].user.contact_phone
                        : null
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }, [_vm._v("Preferences:")]),
                _vm._v(" "),
                _c("td", { staticClass: "value" }, [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.sortedQuotes[0].user.preferences &&
                          _vm.sortedQuotes[0].user.preferences.preferences_email
                          ? "- email <br>"
                          : null
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.sortedQuotes[0].user.preferences &&
                          _vm.sortedQuotes[0].user.preferences.preferences_mail
                          ? "- mail <br>"
                          : null
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.sortedQuotes[0].user.preferences &&
                          _vm.sortedQuotes[0].user.preferences.preferences_phone
                          ? "- phone <br>"
                          : null
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.sortedQuotes[0].user.preferences &&
                          _vm.sortedQuotes[0].user.preferences.preferences_sms
                          ? "- sms <br>"
                          : null
                      )
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "label" }),
                _vm._v(" "),
                _c("td", [
                  _vm.sortedQuotes[0].step2
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-gradient",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.loadQuote(_vm.sortedQuotes[0].id, 2)
                            }
                          }
                        },
                        [_vm._v("Edit contact details and preferences")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.sortedQuotes[0].step2
                    ? _c("span", { staticStyle: { color: "grey" } }, [
                        _vm._v("Edit contact details andpreferences")
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      {
        staticClass: "masthead masthead--inner",
        staticStyle: { "margin-bottom": "0px" }
      },
      [
        _c("div", { staticClass: "in" }, [
          _c(
            "div",
            {
              staticClass: "masthead__slide",
              staticStyle: {
                background:
                  'rgba(0, 0, 0, 0) url("../../../../../../static/styles/mailkit/img/banner.jpg") no-repeat scroll center center / cover',
                width: "100%",
                display: "inline-block"
              }
            },
            [
              _c("div", { staticClass: "masthead__caption" }, [
                _c("h3", { staticStyle: { "text-transform": "capitalize" } }, [
                  _vm._v("retrieve your quote")
                ])
              ])
            ]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("No quotes found."),
      _c("br"),
      _vm._v("Please check the quote ID and email address are correct.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "text-align": "center",
          "font-size": "24px",
          color: "#0170C0",
          "background-color": "white",
          padding: "6px 14px"
        }
      },
      [
        _c("h5", { staticStyle: { margin: "42px 8px" } }, [
          _vm._v(
            "Progress your quote or update your personal details and contact preferences"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "supportPanel" }, [
      _c("div", { staticClass: "in container" }, [
        _c("div", { staticClass: "supportPanel__title" }, [
          _c("h2", { staticStyle: { "font-size": "1.7rem" } }, [
            _vm._v(
              "Need help with your quote? Please contact our support team."
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "supportPanel__blocks blocks" }, [
          _c("div", { staticClass: "in" }, [
            _c("div", { staticClass: "blocks__block block" }, [
              _c("div", { staticClass: "in" }, [
                _c("h5", [_vm._v("LIVE CHAT")]),
                _vm._v(" "),
                _c("div", { staticClass: "blockImg" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://themailingexpert.com/wp-content/themes/ctmk/assets/img/livechat.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Our Live chat is available from 9am - 5.30 pm ")
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "blocks__block block",
                attrs: { href: "tel:+13300947497" }
              },
              [
                _c("div", { staticClass: "in" }, [
                  _c("h5", [_vm._v("CALL OUR SUPPORT TEAM ")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "blockImg" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://themailingexpert.com/wp-content/themes/ctmk/assets/img/call.png"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Call US On: 0330 124 1977")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "blocks__block block",
                attrs: { href: "mailto:customerservices@themailingexpert.com" }
              },
              [
                _c("div", { staticClass: "in" }, [
                  _c("h5", [_vm._v("E MAIL US")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "blockImg" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://themailingexpert.com/wp-content/themes/ctmk/assets/img/email.png"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Email Us: "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "mailto:customerservvices@themailingexpert.com"
                        }
                      },
                      [_vm._v("customerservices@themailingexpert.com")]
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e2868aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e2868aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Retrieve.vue
// module id = null
// module chunks = 